/**
 * Blindly — footer "Your Privacy Choices" control.
 * Drives the opt-out toggle and reflects the current state set by
 * snippets/privacy-consent-head.liquid (window.BlindlyConsent).
 */
(function () {
  var root = document.querySelector('[data-privacy-choices]');
  if (!root || !window.BlindlyConsent) return;

  var btn = root.querySelector('[data-privacy-toggle]');
  var label = root.querySelector('[data-privacy-label]');
  var status = root.querySelector('[data-privacy-status]');

  function render() {
    var out = !!window.BlindlyConsent.optedOut;
    btn.setAttribute('aria-pressed', out ? 'true' : 'false');

    if (out) {
      label.textContent = "You've opted out of advertising tracking";
      if (window.BlindlyConsent.gpcOverridesChoice) {
        status.textContent = 'Your browser’s Global Privacy Control signal overrides the earlier choice made on this device. Tap to allow anyway.';
      } else if (window.BlindlyConsent.gpc && !window.BlindlyConsent.hasExplicitChoice) {
        status.textContent = 'Auto-applied from your browser’s Global Privacy Control signal. Tap to allow.';
      } else {
        status.textContent = 'Advertising & analytics trackers are disabled on this device. Tap to allow.';
      }
    } else {
      label.textContent = 'Your Privacy Choices: Do Not Sell or Share My Personal Information';
      status.textContent = 'Advertising & analytics tracking is currently active on this device.';
    }
  }

  btn.addEventListener('click', function () {
    var next = !window.BlindlyConsent.optedOut;
    window.BlindlyConsent.set(next);
    render();
  });

  render();
})();
